import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|noticeId|sourceId|memberId|ownerMemberId|creatorMemberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

function listConfig(cursor = {}) {
  const params = {};
  if (cursor.limit != null) params.limit = cursor.limit;
  if (cursor.cursorCreateTime && cursor.cursorNoticeId) {
    params.cursorCreateTime = cursor.cursorCreateTime;
    params.cursorNoticeId = cursor.cursorNoticeId;
  }
  return { ...snowflakeJson, params };
}

export const journeyNoticeApi = {
  list: (journeyId, cursor) => travelClient.get(
    travelEndpoints.journeyNotices(journeyId),
    listConfig(cursor),
  ),
  getUnreadCount: (journeyId) => travelClient.get(
    travelEndpoints.journeyNoticeUnreadCount(journeyId),
    snowflakeJson,
  ),
  markRead: (journeyId, noticeId, body) => travelClient.post(
    travelEndpoints.journeyNoticeRead(journeyId, noticeId),
    body,
    snowflakeJson,
  ),
  acknowledge: (journeyId, noticeId, body) => travelClient.post(
    travelEndpoints.journeyNoticeAcknowledge(journeyId, noticeId),
    body,
    snowflakeJson,
  ),
};
